import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiPromptsService } from '../../shared/services/api/prompts/api-prompts.service';
import { PromptInterface } from '../../models/prompt';
import { ToastMessageStackService } from '../../shared/services/toast-message-stack.service';

@Component({
  selector: 'app-smart-search-prompt-modal',
  templateUrl: './smart-search-prompt-modal.component.html',
  styleUrl: './smart-search-prompt-modal.component.scss',
})
export class SmartSearchPromptModalComponent {
  @ViewChild('successToast', { read: TemplateRef }) successToast!: TemplateRef<any>;

  PROMPT_TITLE_CHAR_LIMIT = 70;
  request?: Promise<any>;

  promptId?: number;
  initialPrompt = '';
  prompt = '';
  title = '';

  constructor(
    protected modal: NgbActiveModal,
    private apiPromptsService: ApiPromptsService,
    private toastMessageStackService: ToastMessageStackService
  ) {}

  onPromptChange($event: string) {
    this.prompt = $event;
  }

  cancel(): void {
    this.modal.dismiss();
  }

  delete(): void {
    if (!this.promptId || this.request) {
      return;
    }
    this.request = this.apiPromptsService.deletePrompt(this.promptId).then(() => {
      this.toastMessageStackService.show(this.successToast, {
        autohide: true,
        classname: 'success-toast toast-shape',
        content: 'search.prompt-modal.toast-deleted',
        name: this.title,
      });
      this.modal.close();
    });
  }

  confirm(): void {
    if ((!this.title && !this.prompt) || this.request) {
      return;
    }
    this.request = this.apiPromptsService.upsertPrompt(this.title, this.prompt, this.promptId).then(res => {
      const toastContent = this.promptId ? 'search.prompt-modal.toast-modified' : 'search.prompt-modal.toast-created';
      this.toastMessageStackService.show(this.successToast, {
        autohide: true,
        classname: 'success-toast toast-shape',
        content: toastContent,
        name: this.title,
      });

      this.modal.close({ id: this.promptId ?? res.prompt_id, title: this.title, text: this.prompt } as PromptInterface);
    });
  }
}
